import { put, call } from "redux-saga/effects";
import * as apis from "../../network/apis/registeredUser";
import { getRegisteredUserResponse } from "./actions";

export function* getRegisteredUserSaga({ payload }) {
  try {
    const response = yield call(apis.getRegisteredUserList, payload);

    yield put(
      getRegisteredUserResponse({
        list: response?.data.data.users,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"]
        }
      })
    );
  } catch (err) {
    console.error(err);
  }
}
